export const DEFAULT_INPUT_NAME = 'q'
